// extracted by mini-css-extract-plugin
export var buttonContent = "_6w-0";
export var downloadButton = "_6w-3";
export var dropdownContainer = "_6w-1";
export var icon = "_6w-5";
export var labelButton = "_6w-2";
export var pickupButton = "_6w-4";
export var section = "_6w-6";
export var shipmentCounter = "_6w-7";